<template>
  <!-- 选择内容的弹出框  -->
  <div>
    <el-dialog title="添加酒店周边推荐"
               class="content-dialog"
               :visible.sync="visible"
               :show="show"
               top="10vh"
               width="80%"
               @open="openDialog"
               @close="handleClose">

      <div style="display:flex"
           v-loading='loading'>

        <!-- -------------迹点列表------------- -->
        <div class="traver-add-recommend-area">

          <!-- 列表 -->
          <div class="traver-card-check-list">
            <card-One-list :cardList="traver_point_list"
                           :checkedList="band_Traver_list"
                           :showUpdate="false"
                           :showDest="false"
                           :showTag="false"
                           titleMiniName=""
                           @checkedItem="checkedItem"
                           @clickTraverPoint="clickTraverPointCard"
                           @loadMorTraverPointer="loadMorTraverPointer"
                           buttonName=""></card-One-list>
          </div>
          <!-- 确认新建按钮 -->
          <div v-if="recommend_id==null"
               style="margin-left:auto;margin-top:10px;text-align:center">
            <el-button @click="creatNewTraverContent"
                       type="primary"
                       style="width:100%"
                       size="mini">新建推荐</el-button>

          </div>
          <!-- 修改 推荐 -->
          <div v-else
               style="margin-left:auto;margin-top:10px;text-align:center">
            <el-button @click="reNewTraverContent"
                       type="primary"
                       style="width:100%"
                       size="mini">修改推荐</el-button>

          </div>

        </div>

        <!-- 地图与筛选 -->
        <div class="content-card-check-map">
          <!-- 筛选区 -->
          <div class="filter-area">
            <!-- 目的地 -->
            <div>
              <select-dest placeholder="所属目的地"
                           :destShowBack='destShowBack'
                           @selectDest="selectDest"></select-dest>
            </div>
            <!-- 搜索 -->
            <el-input size="mini"
                      style="width:50%;margin-left:20px"
                      placeholder="请输入该目的地迹点名称"
                      v-model="searchContentKeyword"
                      clearable>
              <el-button slot="append"
                         @click="searchButton"
                         icon="el-icon-search"></el-button>
            </el-input>
          </div>
          <!-- 地图 -->
          <slot name="map"></slot>

        </div>
      </div>

    </el-dialog>
  </div>
</template>

<script>
import SelectDest from '../select/SelectDest'
import SelectTag from '../select/SelectTag'
import CardOneList from '../cards/CardOneList'
export default {
  name: 'select-and-search-content',
  components: {
    'select-dest': SelectDest,
    'select-tag': SelectTag,
    'card-One-list': CardOneList,
  },
  data() {
    return {
      recommend_id: null,
      loading: false,
      visible: this.show,
      searchContentKeyword: '',
      dest: '',
      traver_point_list: this.TraverPointList, //显示的迹点列表

      contentTags: [],
      tag_list: [],
      // 迹点列表
      destShowBack: null,
      // 创建推荐所需的数据
      band_Traver_list: [], // 需要绑定的迹点id
    }
  },
  props: {
    TraverPointList: Array,
    // 对话框用于传递是否显示
    show: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    TraverPointList(newValue) {
      this.traver_point_list = newValue
    },
    show: {
      immediate: true,
      handler(val) {
        this.visible = val
      },
    },
  },
  mounted() {
    // this.$refs.showLocationOnMap.lat = this.lat
    // this.$refs.showLocationOnMap.lng = this.lng
    // this.$refs.showLocationOnMap.pointerOnMap()
    // 获取目的地，再传入目的地
  },
  methods: {
    // 打开对话框时
    openDialog() {
      // this.getAllContentTag()
    },
    // 关闭回调
    handleClose() {
      // this.traver_point_list = []
      this.recommend_id = null
      this.band_Traver_list = []
      // console.log('清空迹点选择', this.band_Traver_list)
      this.$emit('update:show', false)
    },
    // 选择内容
    checkedItem(val) {
      this.band_Traver_list = val
    },
    // 点击选择目的地
    selectDest(value) {
      this.dest = value
    },
    // 点击 迹点 图片，让其剧中显示
    clickTraverPointCard(val) {
      console.log('card_one_list传递的数据', val)
      this.$emit('clickTraverPointCard', val)
    },
    // 点击搜索按钮
    searchButton() {
      let post_item = {
        key_word: this.searchContentKeyword,
        dest: this.dest,
      }

      this.$emit('searchButton', post_item)
    },
    // 选择标签的回调
    getSelectList() {},
    // 获取 内容 的所有标签【没必要，且不执行】
    getAllContentTag() {
      this.$http.get('/traver/get_content_tag').then((res) => {
        const { errno, errmsg, tag_list } = res.data
        if (errno == '0') {
          this.contentTags = tag_list
          // console.log(this.contentTags)
        } else {
          this.$message({
            message: errmsg,
            type: 'warning',
          })
        }
      })
    },
    loadMorTraverPointer() {
      let post_item = {
        key_word: this.searchContentKeyword,
        dest: this.dest,
      }
      this.$emit('loadMorTraverPointer', post_item)
    },

    //  新建 推荐
    creatNewTraverContent() {
      // console.log(this.band_Traver_list)
      this.$emit('creatNewTraverContent', this.band_Traver_list)
    },
    // 修改周边推荐
    reNewTraverContent() {
      let newrecommend = {
        recommend_id: this.recommend_id,
        title: this.input_recommsnd_title,
        introduce: this.recommend_text_area,
        id_list: this.band_Traver_list,
      }
      this.$emit('reNewTraverContent', newrecommend)
    },
  },
}
</script>

<style>
/* .content-dialog .el-dialog__body {
  background-color: red;

} */

.filter-area {
  display: flex;
  margin-bottom: 10px;
  justify-content: flex-end;
}
.traver-add-recommend-area {
  width: 30%;
  max-height: 550px;
}

.traver-card-check-list {
  overflow: scroll;
  padding: 5px;
  width: 96%;
  height: 400px;
  margin-top: 40px;
  border: 1px solid rgb(204, 204, 204);
  background-color: rgb(240, 240, 240);
}
.content-card-check-map {
  width: 70%;
  padding-left: 10px;
}
</style>